import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import qs from 'qs';
import { getApiEndpoint } from './utilities/getApiEndpoint.esm.js';

var formatFeatureFlags = function formatFeatureFlags(featureFlagResponseItems) {
  return featureFlagResponseItems.reduce(function (accumulator, flagResponseItem) {
    var _extends2;

    return _extends({}, accumulator, (_extends2 = {}, _extends2[flagResponseItem.name] = flagResponseItem.value, _extends2));
  }, {});
};

var featureFlagsQuery = /*#__PURE__*/"\n  query($featureFlags: [String!]!, $trackingId: String, $allowlistValues: [String!]) {\n    checkFeatureFlags(flags: $featureFlags, trackingId: $trackingId, allowlistValues: $allowlistValues) {\n      name\n      value\n    }\n  }\n".trim();

var fetchFeatureFlags = function fetchFeatureFlags(_ref) {
  var featureFlags = _ref.featureFlags,
      trackingId = _ref.trackingId,
      allowlistValues = _ref.allowlistValues,
      host = _ref.host;
  var targetHost = host || getApiEndpoint();
  var queryString = qs.stringify({
    query: featureFlagsQuery,
    variables: {
      featureFlags: featureFlags,
      trackingId: trackingId,
      allowlistValues: allowlistValues
    }
  }, {
    arrayFormat: 'brackets'
  });
  return fetch(targetHost + "/graphql?" + queryString, {
    method: 'GET',
    mode: 'cors',
    credentials: 'omit'
  }).then(function (response) {
    if (!response.ok) return Promise.reject();
    return response;
  }).then(function (response) {
    return response.json();
  }).then(function (json) {
    if (!json.data) {
      return [];
    }

    return json.data.checkFeatureFlags;
  })["catch"](function () {
    return [];
  }).then(formatFeatureFlags);
};

export default fetchFeatureFlags;
//# sourceMappingURL=fetchFeatureFlags.esm.js.map
